var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"playvideo",attrs:{"id":"playvideo"}},[_c('video',{ref:"video",staticClass:"playvideocon",attrs:{"name":"playvideocon","poster":_vm.posterUrl},on:{"contextmenu":function($event){$event.preventDefault();}}},[_vm._v("\n    Your browser is too old which doesn't support HTML5 video.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a272a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bussiness/video/flvplayer.vue
// module id = null
// module chunks = 